import { useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'new_patient',
    viewPath: props.viewPath,
  })

  return async function onClick() {
    return submit({ type: 'registerPatient', check_existing: true })
  }
}
